import { createSlice } from "@reduxjs/toolkit";
import {
  getUserNotifications,
  markNotificationAsRead,
  notificationMarkAllAsRead,
  notificationDeleteAll,
} from "./NotificationActions";

const initialState = {
  loading: false,
  getUserNotificationsLoading: false,
  notificationMarkAllAsReadLoading: false,
  notificationDeleteAllLoading: false,
  userNotifications: [],
  error: null,
  success: false, // for monitoring the registration process.
};

const NotificaionSlice = createSlice({
  name: "NotificaionSlice",
  initialState,
  reducers: {},
  extraReducers: {
    [getUserNotifications.fulfilled]: (state, { payload }) => {
      state.getUserNotificationsLoading = false;
      state.success = true;
      state.userNotifications = payload.data;
    },
    [getUserNotifications.pending]: (state, { payload }) => {
      state.getUserNotificationsLoading = true;
    },
    [getUserNotifications.rejected]: (state, { payload }) => {
      state.getUserNotificationsLoading = false;
      state.userNotifications = payload;
    },
    [markNotificationAsRead.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.success = true;
      state.userNotifications = payload.data;
    },
    [markNotificationAsRead.pending]: (state, { payload }) => {
      state.loading = true;
    },
    [markNotificationAsRead.rejected]: (state, { payload }) => {
      state.loading = false;
      // state.userNotifications = payload
    },
    [notificationMarkAllAsRead.fulfilled]: (state, { payload }) => {
      state.notificationMarkAllAsReadLoading = false;
      state.success = true;
      state.userNotifications = payload.data;
    },
    [notificationMarkAllAsRead.pending]: (state, { payload }) => {
      state.notificationMarkAllAsReadLoading = true;
    },
    [notificationMarkAllAsRead.rejected]: (state, { payload }) => {
      state.notificationMarkAllAsReadLoading = false;
      // state.userNotifications = payload
    },
    [notificationDeleteAll.fulfilled]: (state, { payload }) => {
      state.notificationDeleteAllLoading = false;
      state.success = true;
      state.userNotifications = payload.data;
    },
    [notificationDeleteAll.pending]: (state, { payload }) => {
      state.notificationDeleteAllLoading = true;
    },
    [notificationDeleteAll.rejected]: (state, { payload }) => {
      state.notificationDeleteAllLoading = false;
      // state.userNotifications = payload
    },
  },
});

export default NotificaionSlice.reducer;
